import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { FeatureExportsSymbol } from '@wix/thunderbolt-symbols'
import type {
	ISiteScrollBlockerServiceConfig,
	ISiteScrollBlockerService,
	ISiteScrollBlockerDefinition } from '@wix/viewer-service-site-scroll-blocker/definition'
import {
	SiteScrollBlockerDefinition as definition
} from '@wix/viewer-service-site-scroll-blocker/definition'
import { SiteScrollBlockerService as impl } from '@wix/viewer-service-site-scroll-blocker/implementations'
import type { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import { name } from 'feature-site-scroll-blocker'

const shouldBlockScrollWithoutVar = process.env.PACKAGE_NAME !== 'thunderbolt-ds'

export const SiteScrollBlockerService = withDependencies(
	[named(FeatureExportsSymbol, name)],
	(
		siteScrollBlockerExports: IFeatureExportsStore<typeof name>
	): ServiceProvider<
			ISiteScrollBlockerDefinition,
			(opts: ServiceFactoryOpts<ISiteScrollBlockerServiceConfig>) => ISiteScrollBlockerService
		> => {
		const config: ISiteScrollBlockerServiceConfig = {
			onSiteScrollBlockChanged: (status) => {
				siteScrollBlockerExports.export({
					isScrollingBlocked: status,
				})
			},
			shouldBlockScrollWithoutVar,
		}

		return {
			definition,
			impl,
			config,
		}
	}
)
